import React from 'react';
import { Star } from 'lucide-react';
import { ShishaMix } from '../types';

interface MixCardProps {
  mix: ShishaMix;
  onClick: () => void;
}

export default function MixCard({ mix, onClick }: MixCardProps) {
  return (
    <button
      type="button"
      className="mix-card glass-panel"
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        textAlign: 'left',
        height: '100%',
        gap: '12px',
        minHeight: '160px',
        backgroundColor: 'var(--color-surface)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
      }}
    >
      {/* Title */}
      <h3
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          margin: 0,
          color: 'var(--color-text)',
          fontFamily: 'var(--font-heading)',
          lineHeight: '1.3',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {mix.title}
      </h3>

      {/* Creator */}
      <div style={{ fontSize: '12px', opacity: 0.6, marginTop: '-4px' }}>
        by {mix.creator}
      </div>

      {/* Flavors List */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          marginTop: '8px',
        }}
      >
        {mix.flavors.slice(0, 3).map((f) => (
          <div
            key={`${f.brand}-${f.name}`}
            style={{
              fontSize: '14px',
              color: 'rgba(231, 228, 223, 0.9)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <span
              style={{ opacity: 0.6, fontSize: '12px', marginRight: '6px' }}
            >
              {f.brand}
            </span>
            {f.name}
          </div>
        ))}
        {mix.flavors.length > 3 && (
          <div style={{ fontSize: '12px', color: 'rgba(231, 228, 223, 0.5)' }}>
            他 {mix.flavors.length - 3} 種
          </div>
        )}
      </div>

      {/* Rating */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          alignSelf: 'flex-end',
          marginTop: 'auto',
          backgroundColor: 'rgba(26, 28, 31, 0.4)',
          padding: '4px 8px',
          borderRadius: '12px',
        }}
      >
        <Star
          size={14}
          fill="var(--color-accent)"
          color="var(--color-accent)"
        />
        <span
          style={{
            fontSize: '13px',
            fontWeight: 'bold',
            fontFamily: 'var(--font-numbers)',
          }}
        >
          {mix.rating.toFixed(1)}
        </span>
      </div>
    </button>
  );
}
